import React from 'react';

import * as Sentry from '@sentry/react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { routes } from '@/router/routes';

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);
const router = sentryCreateBrowserRouter(routes);

export const AppRouter: React.FC = () => <RouterProvider router={router} />;
